import "./Toggle.css";

type Props = {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  label?: string;
  sub?: string;
};

export function Toggle({ checked, onChange, disabled, label, sub }: Props) {
  const sw = (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={`ui-toggle ${checked ? "on" : ""}`}
      onClick={() => !disabled && onChange(!checked)}
    >
      <span className="ui-toggle-knob" />
    </button>
  );
  if (!label && !sub) return sw;
  return (
    <label className="ui-toggle-row">
      <div className="ui-toggle-text">
        {label && <div className="ui-toggle-label">{label}</div>}
        {sub && <div className="ui-toggle-sub">{sub}</div>}
      </div>
      {sw}
    </label>
  );
}
